var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.867,
    height: 12.867,
    viewBox: "0 0 12.867 12.867"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.823 8.685 2.574 6.433l-.751.751 3 3 6.434-6.434-.749-.748Z",
    className: "b"
  })));
};
export { SvgCheckmark as Icon };
export default __webpack_public_path__ + "static/media/b2166f1fa886aa70ac71d55da586ecf6.svg";